import React from "react"

export interface LinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
    variant?: "default" | "subtle" | "underline"
    disabled?: boolean
}

const Link = React.forwardRef<HTMLAnchorElement, LinkProps>(
    ({ className = "", variant = "default", disabled = false, ...props }, ref) => {
        const baseStyles = "inline-flex items-center justify-center font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed"

        const variantStyles = {
            default: "text-[var(--interactive-primary)] hover:text-[var(--interactive-primary-hover)] active:text-[var(--interactive-primary-hover)]",
            subtle: "text-[var(--text-secondary)] hover:text-[var(--text-primary)] active:text-[var(--text-primary)]",
            underline: "text-[var(--interactive-primary)] underline hover:text-[var(--interactive-primary-hover)] active:text-[var(--interactive-primary-hover)]"
        }

        return (
            <a
                ref={ref}
                className={`${baseStyles} ${variantStyles[variant]} ${className}`}
                aria-disabled={disabled}
                {...(disabled && { onClick: (e: { preventDefault: () => any }) => e.preventDefault() })}
                {...props}
            />
        )
    }
)

Link.displayName = "Link"

export { Link }